import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CountryResponse, DepartmentResponse, TownResponse, WarehouseCategoryResponse, WarehouseRequest, WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { User } from 'src/app/models/user.model';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { ProductService } from 'src/app/services/product.service';
import { CatalogResponse, MeasurementsResponse } from 'src/app/models/catalog.model';
import { PlaceService } from 'src/app/services/place.service';
import { Place } from 'src/app/models/place.model';

@Component({
  selector: 'app-modal-create-warehouse',
  templateUrl: './modal-create-warehouse.component.html',
  styleUrls: ['./modal-create-warehouse.component.scss']
})
export class ModalCreateWarehouseComponent implements OnInit {
  countries: CountryResponse[] = [];
  departments: DepartmentResponse[] = [];
	permissionType = PermissionTypeEnum;
  towns: TownResponse[] = [];
  catalogs: CatalogResponse;
  measurementsWeight: MeasurementsResponse[];
  department = 0;
  town = 0;
  country = 0;
  users: User[] = [];
  places: Place[] = [];
  warehouseCategories: WarehouseCategoryResponse[] = [];
  newWarehouse = new WarehouseRequest();
  loading = false;
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private warehouseService: WarehouseService,
    private placeService: PlaceService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private productService: ProductService,
    private roleService: RolesAndPermissionsService
  ) {
    this.newWarehouse.storeCategory = 1;
    this.newWarehouse.manager = 0;
  }

  ngOnInit(): void {
    this.getCountries();
    this.getUsers();
    this.getWarehouseCategories();
    this.getCatalogs();
    this.getPlaces();
  }

  getWarehouseCategories(){
    this.warehouseService.getCategoryWarehouses().subscribe({
      next: (response:ResponseObject)=>{
        this.warehouseCategories = response.data;
      },
      error: (error: any) => {
        this.toastService.error("No se pudo cargar las categorias de bodega")
      }
    })
  }

  getUsers() {
    this.roleService.getUsers(parseInt(this.authService.getCurrentCompanyId())).subscribe({
      next: (response:ResponseObject)=>{
        this.users = response.data;
      },
      error: (error: any) => {
        this.toastService.error("No se pudo cargar los usuarios")
      }
    })
  }

  getCountries(){
    this.warehouseService.getCountry().subscribe({
      next: (response: ResponseObject) => {
        this.countries = response.data;
        this.newWarehouse.country = this.countries[0].id;
        this.departments = [];
        this.getDepartments();
      },
      error: (error: any) => {
        this.toastService.error("No se pudo cargar los paises disponibles")
      }
    })
  }

  getDepartments(){
    this.warehouseService.getDepartmentsByCountry(this.newWarehouse.country).subscribe({
      next: (response: ResponseObject) => {
        this.departments = response.data;
        if (this.departments.length > 0){
          this.newWarehouse.department = this.departments[0].id;
          this.getTowns();
        } else {
          this.towns = [];
          this.newWarehouse.town = 0;
          this.departments = [];
          this.newWarehouse.department = 0;
          this.toastService.info("No se tiene información sobre los departamentos del país elegido");
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("No se pudieron obtener los departamentos");
        }
      }
    })
  }

  getTowns(){
    this.warehouseService.getTownsByDepartment(this.newWarehouse.department,this.newWarehouse.country).subscribe({
      next: (response: ResponseObject) => {
        this.towns = response.data;
        if (this.towns.length >0 ){
          this.newWarehouse.town = this.towns[0].id;
        } else {
          this.towns = [];
          this.newWarehouse.town = 0;
          this.toastService.success("No se tiene información sobre las ciudades del departamento elegido");
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("No se pudieron obtener las ciudades");
        }
      }
    })
  }
  
  getCatalogs(){
    this.productService.getCatalogs().subscribe({
      next: (response: ResponseObject) => {
        this.catalogs = response.data;
        this.measurementsWeight = [];
        if (this.catalogs.measurements.length >0) {
          this.catalogs.measurements.forEach(element => {
            if (element.category == 4) {
              this.measurementsWeight.push(element);
            }
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getPlaces() {
    this.placeService.getPlaces().subscribe({
      next: (response: ResponseObject) => {
        this.places = response.data;
        console.log(this.places);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  postWarehouse(){
    this.loading = true;
    this.warehouseService.postWarehouse(this.newWarehouse).subscribe({
      next: (response: ResponseObject) => {
        console.log(response);
        this.toastService.success('Bodega creada correctamente!');
      this.loading = false;
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("Error al guardar la bodega");
        }
      }
    })
  }
}
